import * as _4 from 'lodash4';
import { IAvailableLocation, IContactAvailableTimes } from '../../../contact_interfaces';

export class AvailabilityTileContactController {
  private availabilityList: IContactAvailableTimes[];
  private availabilityByService: IAvailableLocation;

  constructor(private $sce: ng.ISCEService) {
    this.availabilityList = this.availabilityList || {};
  }

  $onInit(): void {
    this.update();
  }

  $onChanges(changes: ng.IChangesObject): void {
    if (_4.isEmpty(changes)) {
      return;
    }

    this.update();
  }

  update() {
    this.availabilityList = this.createAvailableDaysArray(this.availabilityList);
    this.availabilityByService = this.setAvailabilityByPurpose(this.availabilityList);
  }

  getAvailabilityPurpose(availabilityArr: IContactAvailableTimes[]): string {
    return _4.get(_4.head(availabilityArr), 'purpose', '');
  }

  showContactDaysTimeSection(availableByService: IContactAvailableTimes): boolean {
    return availableByService.dates.toLowerCase() !== 'forever';
  }

  getContactServicesString(availability: IContactAvailableTimes): string {
    return _4.isEmpty(availability) ? '' : _4.map(availability.services, 'name').join(', ');
  }

  setAvailabilityByPurpose(availability: IContactAvailableTimes[]): IAvailableLocation {
    return _4.groupBy(availability, (available: IContactAvailableTimes) => {
      return available.purpose;
    });
  }

  createAvailableDaysArray(availability: IContactAvailableTimes[]): IContactAvailableTimes[] {
    _4.forEach(availability, (currentAvailability: IContactAvailableTimes) => {
      currentAvailability.days_array = _4.map(currentAvailability.days.split(','), (day: string) => _4.trim(day));
    });

    return availability;
  }

  getFullDayName(dayNameShort: string): string {
    const monthNames: object = {
      Sun: 'Sundays',
      Mon: 'Mondays',
      Tue: 'Tuesdays',
      Wed: 'Wednesdays',
      Thu: 'Thursdays',
      Fri: 'Fridays',
      Sat: 'Saturdays'
    };
    return monthNames[dayNameShort];
  }
  getMeetingTypeString(availability: IContactAvailableTimes): string {
    if(_4.isEmpty(availability)||!availability.meeting_types){
      return 'N/A';
    } else {
      return availability.meeting_types.join(', ');
    }
  }
  getSpecialInstructions(availability: IContactAvailableTimes): string {
    if(_4.isEmpty(availability)||!availability.details){
      return '--';
    } else {
      return this.$sce.trustAsHtml(availability.details)
    }
  }
}

export class ContactTileAvailabilityComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-resources/src/components/people/contact_tile_availability/contact_tile_availability.html';
  public controller: any = AvailabilityTileContactController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    availabilityList: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/components/people/contact_tile_availability/contact_tile_availability_controller.ts